import React, { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { Navbar } from "../../Components/Navbar/Navbar";
import { Footer } from "../../Components/Footer/footer";
import "./style.css";

export function IstoricPage() {
  const [headerImage, setHeaderImage] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      const ref = doc(db, "site_content", "history_page");
      const snap = await getDoc(ref);
      if (snap.exists()) {
        const data = snap.data();
        setHeaderImage(data.header_image || "");
        setTitle(data.title || "");
        setDescription(data.description || "");
      }
    };
    fetchData();
  }, []);

  return (
    <div className="page-container">
      <Navbar />

      {headerImage && (
        <div className="history-banner" style={{ backgroundImage: `url(${headerImage})` }} />
      )}

      <div className="page-content">
        <h1>{title}</h1>
        <p className="history-description">{description}</p>
      </div>

      <Footer />
    </div>
  );
}
